module.exports = __webpack_public_path__ + "img/call-disabled.5630ab16.svg";